<template>
    <modals-side-generic
    invertTitleSubtitle
    :preventDetailsModalClose="preventDetailsModalClose"
    :title="title || t('filters.title')"
    :subTitle="subTitle"
    :showFooter="showButtons"
    :buttonsFooterData="buttonsFooterData"
    :triggerClose="triggerClose"
    @hideMe="emit('hideMe')">
        <slot></slot>
    </modals-side-generic>
</template>

<script setup>
import ModalsSideGeneric from '@/components/generic/modals/side/Generic'
/* Vue */
import { ref, watch, onBeforeUnmount } from 'vue'
/* Store */
import { mapActions, mapGetters } from '@/store/helpers/mappers'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['hideMe', 'clearFilters', 'applyFilters'])

/* Props
@stitle {String} - text to display in our title
@subTitle {String} - text to display under our title
@showButtons {Boolean} - prop to display filter buttons and apply necessary styles
@triggerClose {Boolean} - prop to trigger close of filter modal so animation happens before our modal disapears
@preventDetailsModalClose{Boolean} - prop to prevent details modal close trigger
*/
const props = defineProps({
    title: String,
    subTitle: String,
    showButtons: Boolean,
    triggerClose: Boolean,
    preventDetailsModalClose: Boolean
})

const { updatePreventMobileFeatureBack, updateFooterShowState } = mapActions()

const showModalWrapper = ref(false)

const buttonsFooterData = [{
    label: t('filters.clearFiltersModal'),
    buttonPosition: 'left',
    icon: 'close',
    callbackFunction: () => { emit('clearFilters') }
}, {
    label: t('filters.applyFilters'),
    buttonType: 'primary',
    icon: 'check-line',
    iconPosition: 'right',
    callbackFunction: () => { emit('applyFilters') }
}]

watch(() => props.triggerClose, () => { showModalWrapper.value = false })

watch(() => props.showButtons, (newVal, oldVal) => {
    updateFooterShowState(props.showButtons)
})

updateFooterShowState(props.showButtons)

/***********************************************************
*                                                          *
*                 MOBILE NATIVE BACK LOGIC                 *
*                                                          *
***********************************************************/
/* Preving mobile back to trigger features close */
updatePreventMobileFeatureBack(true)
onBeforeUnmount(() => {
	updatePreventMobileFeatureBack(false)
    updateFooterShowState(false)
})

const onBackKeyDown = () => {
    showModalWrapper.value = false
}

document.addEventListener('backbutton', onBackKeyDown, false)
</script>
